import { ENVIRONMENTS } from 'constants/environmentConstant'

const getCurrentEnvironment = () => {
  return ENVIRONMENTS.find(({ hostname }) =>
    hostname === window.location.hostname) || {}
}

export const getEnvironmentName = () => {
  const { environment } = getCurrentEnvironment()
  return environment
}
